import React from "react";
import AllCampaigns from "../component/sections/campaigns/AllCampaigns";
import AddCampaign from "../component/sections/campaigns/AddCampaign";
import AllTypesCampaigns from "../component/sections/campaigns/AllTypesCampaigns";
import AllTypesBannerCampaigns from "../component/sections/campaigns/AllTypesBannerCampaigns";
import AddGroupSitePublisherContainerCampaignBanner from "../component/sections/campaigns/AddGroupSitePublisherContainerCampaignBanner";
import ViewCampaign from "../component/sections/campaigns/ViewCampaign";

const campaignsRoutes = [
  {
    path: "/campaigns/all",
    render: () => <AllCampaigns />,
    exact: true,
  },
  {
    path: "/campaigns/all-type",
    render: () => <AllTypesCampaigns />,
    exact: true,
  },
  {
    path: "/campaigns/all-type-banner",
    render: () => <AllTypesBannerCampaigns />,
    exact: true,
  },
  {
    path: "/campaigns/banner/simple/add-group-site-publisher",
    render: () => <AddGroupSitePublisherContainerCampaignBanner />,
    exact: true,
  },
  {
    path: "/campaigns/banner/simple/add",
    render: () => <AddCampaign />,
    exact: true,
  },
  {
    path: "/campaigns/banner/simple/view/:id",
    render: () => <ViewCampaign />,
    exact: true,
  },
];

export default campaignsRoutes;
